export default {
    NONE:0,
    PAGE:1,
    BLOCK:2,
    MEDIA:3,
    WIDGET:4,
    LISTING_PAGE: 5
};



// WEBPACK FOOTER //
// ./src/core/config/contentDefinitionTypes.js